import userSelectors from 'selectors/user';

const declinePayment = paymentId => {
  return async (dispatch, getState, { paymentGateway }) => {
    const state = getState();
    const { orgId, orgDomain } = state.app;

    const gladlyCustomerId = userSelectors.getGladlyCustomerId(state.user);
    if (!gladlyCustomerId) {
      throw new Error('no gladlyCustomerId found');
    }
    await paymentGateway.decline(orgDomain, orgId, gladlyCustomerId, paymentId);
  };
};

export default declinePayment;
